import { DAYS_OF_WEEK } from 'types/entities/shared/ids'
import { createDateFromString } from 'utils/date'

import type { DayOfWeek } from 'types/entities/shared/ids'

/**
 * Built field by field, never parsed: `new Date('2026-09-21')` is UTC midnight, which reads back as
 * the previous day west of Greenwich and sent every master leg to the wrong weekday.
 */
export const dayOfWeekForServiceDate = (serviceDateIso: string): DayOfWeek | null => {
  const parsed = createDateFromString(serviceDateIso) as Date | null
  if (!parsed || Number.isNaN(parsed.getTime())) return null
  const jsDay = parsed.getDay()
  return DAYS_OF_WEEK[jsDay === 0 ? 6 : jsDay - 1] ?? null
}
